const STORAGE_PREFIX = 'scoreclash.gamesSeenAt.';

function storageKey(username) {
  return `${STORAGE_PREFIX}${String(username || '').trim()}`;
}

/**
 * @param {string | null | undefined} username
 * @returns {number | null} epoch ms, or null if never seeded
 */
export function getGamesSeenAt(username) {
  if (!username) return null;
  try {
    const raw = localStorage.getItem(storageKey(username));
    if (raw == null || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

/**
 * @param {string | null | undefined} username
 * @param {number} timestampMs
 */
export function setGamesSeenAt(username, timestampMs) {
  if (!username) return;
  const ts = Number(timestampMs);
  if (!Number.isFinite(ts)) return;
  try {
    localStorage.setItem(storageKey(username), String(Math.floor(ts)));
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * Finish time used for CTA catch-up (prefer processed standings time).
 * @param {object | null | undefined} game
 * @returns {number | null}
 */
export function gameResultTimestamp(game) {
  if (!game || typeof game !== 'object') return null;
  const processed = Number(game.processedTime);
  if (Number.isFinite(processed) && processed > 0) return processed;
  const terminal = Number(game.terminalAt);
  if (Number.isFinite(terminal) && terminal > 0) return terminal;
  return null;
}

/**
 * @param {object | null | undefined} game
 * @returns {boolean}
 */
export function isFinishedGameForCta(game) {
  if (!game || game.status !== 'finished') return false;
  if (game.voidResult === true) return false;
  return gameResultTimestamp(game) != null;
}

/**
 * Finished games newer than lastSeen (current ∪ previous).
 * @param {object[]} games
 * @param {number} lastSeenMs
 * @returns {object[]}
 */
export function findUnseenFinishedGames(games, lastSeenMs) {
  const lastSeen = Number(lastSeenMs);
  if (!Number.isFinite(lastSeen) || !Array.isArray(games)) return [];
  return games.filter((game) => {
    if (!isFinishedGameForCta(game)) return false;
    const ts = gameResultTimestamp(game);
    return ts != null && ts > lastSeen;
  });
}

/**
 * @param {object[]} games
 * @returns {number}
 */
export function maxGameResultTimestamp(games) {
  let max = 0;
  for (const game of games || []) {
    const ts = gameResultTimestamp(game);
    if (ts != null && ts > max) max = ts;
  }
  return max;
}
